<template>
	<div class="sale-detail-receive-wrap">
		<div style="display: flex;justify-content: space-between;">
			<h2 class="title">收款记录</h2>
			<div 
				style="padding: 32px 16px 16px;font-size: 12px;text-decoration: underline;"
				@click="openAll"
				v-if="data.length > 0"
			>全部展开</div>
		</div>
		
		<van-collapse v-model="activeNames" v-if="data.length > 0">
		  <van-collapse-item v-for="(v, i) in data" :name="i + ''">
		    <template #title>
					<div class="coll-item-title-main">
						<div>{{ v.code }}</div>
						<!-- 收款时间 -->
						<div>{{ v.createdatetime }}</div>
					</div>
		      <div class="coll-item-title-part">
		      	<span style="color: #18bc9c;" v-if="v.status == 0">未收款</span>
		      	<span style="color: #18bc9c;" v-if="v.status == 2">审批中</span>
		      	<span style="color: #18bc9c;" v-if="v.status == 1">已收款</span>
		      	<span>金额: {{ v.amount }}【{{ v.currency }}】</span>
		      </div>
		    </template>
		    <div class="detail-item"><div class="detail-label">收款单号：</div>{{ v.code }}  </div>
		    <div class="detail-item"><div class="detail-label">订单编号：</div> {{ v.order_code }} </div>
		    <div class="detail-item"><div class="detail-label">客&emsp;&emsp;户：</div> {{ v.customer }} </div>
		    <div class="detail-item"><div class="detail-label">收款公司：</div> {{ v.corporation }} </div>
		    <div class="detail-item"><div class="detail-label">订单类型：</div> {{ v.createdatetime }} </div>
		    <div class="detail-item"><div class="detail-label">收款方式：</div> {{ v.createdatetime }} </div>
		    <div class="detail-item"><div class="detail-label">状&emsp;&emsp;态：</div> 
					 <span style="color: #18bc9c;" v-if="v.status == 0">未收款</span>
					 <span style="color: #18bc9c;" v-if="v.status == 2">审批中</span>
					 <span style="color: #18bc9c;" v-if="v.status == 1">已收款</span>
				</div>
		    <div class="detail-item"><div class="detail-label">收款金额：</div> {{ v.amount }}【{{ v.currency }}】 </div>
				<div class="detail-item"><div class="detail-label">创建时间：</div> {{ v.createdatetime }} </div>
		    <div class="detail-item"><div class="detail-label">应收时间：</div> {{ v.predicttime_text }} </div>
		    <div class="detail-item"><div class="detail-label">收款时间：</div> 
						<span>{{ v.paymenttime_text }}</span>
				</div>
		  </van-collapse-item>
		</van-collapse>
		<div 
			v-else
			style="height: 50px;background-color: white;line-height: 50px;text-align: center;border-radius: 5px;"
		>暂无数据</div>
	</div>
</template>

<script>
	export default {
		components: {
			
		},
		props: {
			code: {
				type: [String],
				default: () => {
					return '';
				}
			}
		},
		data() {
		  return {
				activeNames: [],
				data: [],
		  };
		},
		watch: {
			code: function(nv, ov) {
				if (nv) {
					this.getData();
				}
			}
		},
		created() {
		  this.init();
		},
		mounted() {},
		methods: {
		  init() {
				// this.getData();
			},
			getData() {
				this.$post(`${this.$api.stIncomeOrderReconciliation}${this.code}`, {}).then((res) => {
					if (res.code === 200) {
						this.data = res.data.rows;
					} else {
						this.$toast.fail((res.msg ? res.msg : '请求异常，请稍后重试'));
					}
				}).catch((e) => {
					this.$toast.fail(e);
				})
			},
			openAll() {
				for (let i in this.data) {
					if (!this.activeNames.includes(i)) {
						this.activeNames.push(i);
					}
				}
			},
		},
	}
</script>

<style lang="scss" scoped>
	.sale-detail-receive-wrap {
		margin: 24px;
		border-radius: 5px;
		.title {
				margin: 0;
				padding: 32px 16px 16px;
				color: rgba(69, 90, 100, 0.6);
				font-weight: normal;
				font-size: 14px;
				line-height: 16px;
		}
		
		.coll-item-title-main {
			display: flex;
			justify-content: space-between;
		}
		
		.coll-item-title-part {
			span {
				margin-right: 8px;
				font-size: 12px;
				color: #a5a0a0;
			};
		}
		
		.detail-label {
			width: 90px;
			text-align: right;
			display: inline-block;
		}
		
		.detail-item {
			margin-top: 8px;
		}
	}
</style>